module.exports = __webpack_public_path__ + "static/learning-55a7230b0d47a8542ff283ea4bfee94c.jpg";